import type { BillingPlan, PaymentInterval, PricingFeatureSubscription } from '@core/billing-types';

export const getInitialChargebeeInterval = (
  subscription: PricingFeatureSubscription,
  assignedProduct?: BillingPlan,
): PaymentInterval => {
  if (assignedProduct?.billingPeriod) return assignedProduct?.billingPeriod;
  if (subscription?.billingPeriod) return subscription?.billingPeriod;
  return 12;
};
